import { render, staticRenderFns } from "./newsproblem5.vue?vue&type=template&id=305b354b&scoped=true&"
import script from "./newsproblem5.vue?vue&type=script&lang=js&"
export * from "./newsproblem5.vue?vue&type=script&lang=js&"
import style0 from "./newsproblem5.vue?vue&type=style&index=0&id=305b354b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305b354b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/CuR8LQ8M/0/haike/frontend/haike-website/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('305b354b')) {
      api.createRecord('305b354b', component.options)
    } else {
      api.reload('305b354b', component.options)
    }
    module.hot.accept("./newsproblem5.vue?vue&type=template&id=305b354b&scoped=true&", function () {
      api.rerender('305b354b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/news/problem/newsproblem5.vue"
export default component.exports